var map = {
	"./Building.json": 406,
	"./Card.json": 407,
	"./Floor.json": 408,
	"./ObBldg.json": 409,
	"./Org.json": 410,
	"./Util.json": 411
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;


//////////////////
// WEBPACK FOOTER
// ./src/lib/hoverTemplates ^\.\/.*\.json$
// module id = 405
// module chunks = 1